export const COST_RATE_TABLE_DIMENSION_SLUG = {
  PAY_CODE: 'pay-code',
  PROJECT_ROLE: 'project-role',
  TASK_ROLE: 'task-role',
  USER: 'user'
};

export const INCLUDE_DIMENSION_SLUGS = [
  COST_RATE_TABLE_DIMENSION_SLUG.PROJECT_ROLE,
  COST_RATE_TABLE_DIMENSION_SLUG.USER,
  COST_RATE_TABLE_DIMENSION_SLUG.PAY_CODE,
  COST_RATE_TABLE_DIMENSION_SLUG.TASK_ROLE
];

export const OVERRIDE_DIMENSION_PROPS = {
  [COST_RATE_TABLE_DIMENSION_SLUG.PROJECT_ROLE]: intl => ({
    displayText: intl.formatMessage({
      id: 'projectCostOverrides.dimension.primaryRole'
    }),
    sortIndex: 1
  }),
  [COST_RATE_TABLE_DIMENSION_SLUG.USER]: intl => ({
    displayText: intl.formatMessage({
      id: 'projectCostOverrides.dimension.resource'
    }),
    sortIndex: 2
  }),
  [COST_RATE_TABLE_DIMENSION_SLUG.PAY_CODE]: intl => ({
    displayText: intl.formatMessage({
      id: 'projectCostOverrides.dimension.payCode'
    }),
    sortIndex: 3
  }),
  [COST_RATE_TABLE_DIMENSION_SLUG.TASK_ROLE]: intl => ({
    displayText: intl.formatMessage({
      id: 'projectCostOverrides.dimension.taskRole'
    }),
    sortIndex: 4
  })
};
